var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGnome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 1C12.0333 1 11.3307 6.33363 13.4378 6.33363C15.545 6.33363 19.523 1 15.7778 1ZM9.5611 5.67269C10.6827 5.74131 11.9135 1.39769 9.80523 1.666C7.69698 1.93431 8.43835 5.60463 9.5611 5.67269ZM4.41985 8.36875C5.21748 8.01775 4.52279 4.58312 3.16548 5.51969C1.80816 6.45625 3.61548 8.72594 4.41985 8.36875ZM6.6676 6.57156C7.6171 6.37806 7.66885 2.48219 5.97573 3.18138C4.2826 3.88056 5.71866 6.76562 6.6676 6.57156ZM11.6266 15.2943C11.7954 16.5813 10.6827 17.2163 9.59316 16.3872C6.12479 13.7468 15.3307 12.4294 14.7288 8.82156C14.2248 5.82681 5.03691 6.74875 3.98504 11.4344C3.28191 14.6035 6.9061 19 10.6861 19C12.5463 19 14.6911 17.3204 15.0927 15.193C15.3993 13.5708 11.486 14.2199 11.6266 15.2943Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGnome);
export default __webpack_public_path__ + "static/media/ic-gnome.bcc48469246fd8cfb059bef8744a0298.svg";
export { ForwardRef as ReactComponent };